const color = "light.blue";
let render = () => {
  import("./assets/css/sass/themes/dore." + color + ".scss").then((x) => {
    require("./appRenderer");
  });
};
render();
